import React from "react";
import classNames from "classnames";
import styles from "./Section.module.scss";

interface SectionHeaderProps {
    className?: string;
    children?: React.ReactNode;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
    className,
    children,
}) => (
    <header className={classNames(styles.sectionHeader, className)}>
        {children}
    </header>
);

interface SectionProps {
    heading?: string | React.ReactNode;
    subheading?: string | React.ReactNode;
    className?: string;
    children?: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({
    heading,
    subheading,
    className,
    children,
}) => (
    <section className={classNames(styles.section, className)}>
        {heading && (
            <SectionHeader>
                {typeof heading === "string" ? <h4>{heading}</h4> : heading}
            </SectionHeader>
        )}
        {subheading && (
            <header className={styles.sectionSubheader}>{subheading}</header>
        )}
        <main>{children}</main>
    </section>
);
